import { useApp } from "../app/AppContext.jsx";

export default function PhotoPlaceholder() {
  const { t } = useApp();
  return <div className="photo-placeholder">
    <svg viewBox="0 0 240 90" fill="none" aria-hidden="true">
      <path d="M24 62h-9V48l18-6 29-25h83l37 27 35 7 8 11v9h-22M62 71h99M42 42h127M79 20l-9 22m58-22 13 22" />
      <circle cx="43" cy="68" r="17" /><circle cx="182" cy="68" r="17" />
    </svg>
    <span>{t("common.noPhoto")}</span>
  </div>;
}
